// extracted by mini-css-extract-plugin
export default {"amount":"amount_amount__EdUf3","suffix":"amount_suffix__ZIwtt"};